import { Col, Row } from "react-bootstrap";
import { SignupWrapper } from "./styled";
import { useTranslation } from "react-i18next";
import AuthHeader from "../../../components/auth/AuthHeader/AuthHeader";
import { Box, LazyImage } from "../../../components/styled/Elements";
import SignupForm from "./components/SignupForm";
import { LoginRightImage } from "../../../components/styled/AllImages";
import { useLocation } from "react-router-dom";

const SignUp = () => {
  const { i18n, t } = useTranslation();

  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const plan_type = queryParams.get("type");
  const status = queryParams.get("status");

  const planObj = {
    plan_type: plan_type || null,
    id: queryParams.get("plan_id"),
    duration: queryParams.get("duration") || 1,
  };


  return (
    <SignupWrapper lang={i18n.language}>
      <AuthHeader />
      <Box className="mt-4 container-fluid pb-4">
        <Row>
          <Col lg={6} md={6} sm={12} className="px-3 px-xl-5 px-md-5 pb-4">
            <Box>
              <SignupForm planInfo={planObj} />
            </Box>
          </Col>
          <Col lg={6} md={6} sm={12} className="px-3 px-xl-5 auth-slider">
            <Box className="sticky-item">
              <Box style={{ position: "relative" }}>
                <Box className="image-title">
                  <Box>
                    <span className="image-title-one">{t("welcome_to")} </span>{" "}
                    <span className="image-title-two">{t("my_office")}</span>
                  </Box>
                  <p className="image-title-sub-title">
                    {t("streamline_your_workspace")}
                  </p>
                </Box>
                <LazyImage src={LoginRightImage} />
              </Box>
            </Box>
          </Col>
        </Row>
      </Box>
    </SignupWrapper>
  );
};

export default SignUp;
